import { IComposableChartsWidget, ChartFrequency } from 'wisestep-api';

import { generalTimePeriodList } from '../../../../analyticsPage/helper/timePeriodList';
import EmailsBarChartPostgres from '../../../BaseCharts/Emails/new/EmailsBarChartPostgres';
import EmailsMetricPostgres from '../../../BaseCharts/Emails/new/EmailsMetricPostgres';
import EmailsTablePostgres from '../../../BaseCharts/Emails/new/EmailsTablePostgres';
import { ChartScope } from '../../../types';
import { EmailsWidget, getChartFreqForTimePeriod } from '../../helper';

const getChartWidgetByTimeAndScope = (
  timePeriodId: string,
  scope: ChartScope,
  frequency: ChartFrequency = getChartFreqForTimePeriod[timePeriodId]
): Record<EmailsWidget, IComposableChartsWidget> => {
  const defaultQuery = {
    category: 'emails',
    filters: [],
    type: 'EMAIL_COUNT',
    frequency,
    range: timePeriodId,
    scope,
  };
  const freqInRegularCase = frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase();

  const widgets = {
    [EmailsWidget.EMAIL_COUNT]: {
      name: 'Total Emails Sent',
      filters: {},
      type: `metric_emails_${timePeriodId}_${scope}_postgre`,
      category: 'emails',
      component: (
        <EmailsMetricPostgres
          query={{ ...defaultQuery, type: 'EMAIL_COUNT' }}
          title="Total Emails Sent"
          widgetName={EmailsWidget.EMAIL_COUNT}
        />
      ),
    },
    [EmailsWidget.EMAIL_USER]: {
      name: 'Emails Sent by Users by Time',
      filters: {},
      type: `table_users_emails_${timePeriodId}_${scope}_postgre`,
      category: 'emails',
      component: (
        <EmailsTablePostgres
          query={{ ...defaultQuery, type: 'EMAIL_USER' }}
          title="Emails Sent by Users by Time"
          widgetName={EmailsWidget.EMAIL_USER}
        />
      ),
    },
    [EmailsWidget.EMAIL_USER_ONLY]: {
      name: 'Emails Sent by Users',
      filters: {},
      type: `table_users_emails_only_${timePeriodId}_${scope}_postgre`,
      category: 'emails',
      component: (
        <EmailsTablePostgres
          query={{ ...defaultQuery, type: 'EMAIL_USER' }}
          title="Emails Sent by Users"
          widgetName={EmailsWidget.EMAIL_USER_ONLY}
        />
      ),
    },
    [EmailsWidget.EMAIL_JOB]: {
      name: 'Emails Sent by Jobs',
      filters: {},
      type: `table_users_emails_job_${timePeriodId}_${scope}_postgre`,
      category: 'emails',
      component: (
        <EmailsTablePostgres
          query={{ ...defaultQuery, type: 'EMAIL_JOB' }}
          title="Emails Sent by Jobs"
          widgetName={EmailsWidget.EMAIL_JOB}
        />
      ),
    },
    [EmailsWidget.EMAIL_USER_BAR_CHART]: {
      name: `Emails Sent by Users - ${freqInRegularCase}`,
      filters: {},
      type: `barchart_users_emails_${timePeriodId}_${scope}_${frequency}_postgre`,
      category: 'emails',
      component: (
        <EmailsBarChartPostgres
          query={{ ...defaultQuery, type: 'EMAIL_USER' }}
          title={`${freqInRegularCase} Emails Sent by Users`}
          widgetName={EmailsWidget.EMAIL_USER_BAR_CHART}
        />
      ),
    },
  };

  return widgets;
};

export const emailsChartsKeyPostgre = (
  timePeriodId: string,
  scope: ChartScope
): IComposableChartsWidget[] => {
  const defaultWidgets = Object.values(getChartWidgetByTimeAndScope(timePeriodId, scope));
  const additionalWidgets = {};

  return [...defaultWidgets, ...(additionalWidgets[timePeriodId] ?? [])];
};

export const postgreEmailsDashboardKeysObjectList = generalTimePeriodList.flatMap((timePeriod) => [
  ...emailsChartsKeyPostgre(timePeriod.id, ChartScope.WORKSPACE),
  ...emailsChartsKeyPostgre(timePeriod.id, ChartScope.LOGGED_IN_USER),
]);
